/** sessionStorage key for beta invite code before org creation */
export const PENDING_BETA_INVITE_CODE_KEY = "pending_beta_invite_code";
